import React, { useState, useCallback } from 'react';

import { version } from '../../../../package.json';

import { PRODUCTION_ENVIRONMENTS } from './CacheBuster.constants';
import { useVersionCheck } from './hooks/useVersionCheck';
import { refreshCacheAndReload } from './utilities/refreshCacheAndReload';

import type { CacheBusterProperties } from './CacheBuster.types';

export const CacheBuster: React.FC<CacheBusterProperties> = ({
  children,
  currentVersion = version,
  loadingComponent,
  metaFileDirectory = '.',
  checkInterval = 5 * 60 * 1000,
}) => {
  const [cacheStatus, setCacheStatus] = useState({
    loading: true,
    isLatestVersion: false,
  });

  const isEnabled = PRODUCTION_ENVIRONMENTS.includes(import.meta.env.MODE);
  const debug = import.meta.env.MODE === 'staging';

  const handleNewVersionFound = useCallback(() => {
    setCacheStatus({
      loading: false,
      isLatestVersion: false,
    });
  }, []);

  const handleStatusChange = useCallback((isLatestVersion: boolean) => {
    setCacheStatus({
      loading: false,
      isLatestVersion,
    });
  }, []);

  useVersionCheck({
    enabled: isEnabled,
    metaFileDirectory,
    currentVersion,
    checkInterval,
    onNewVersionFound: handleNewVersionFound,
    onStatusChange: handleStatusChange,
    debug,
  });

  if (!isEnabled) {
    return children;
  }

  if (cacheStatus.loading) {
    return children;
  }

  if (!cacheStatus.loading && !cacheStatus.isLatestVersion) {
    /*
     * Рендер не может быть async, поэтому await здесь недоступен, а перенос
     * вызова в useEffect изменил бы момент перезагрузки. Правило подавлено
     * осознанно; ошибки уходят в console.error.
     */
     
    refreshCacheAndReload().catch(console.error);
    return loadingComponent;
  }

  return children;
};
